module.exports = __webpack_public_path__ + "img/LOGO_DOMI communication.21a44b96.png";